export { default as InvoiceComms } from './InvoiceComms'

export default {
  InvoiceComms: require('./InvoiceComms').default
}
